<script>
import DraftIndicator from './DraftIndicator.vue';
import ButtonNext from 'next/button/Button.vue';
import Dropdown from 'next/wgpt/Dropdown/Dropdown.vue';
import DropdownMenu from 'next/dropdown-menu/DropdownMenu.vue';

export default {
  components: {
    DraftIndicator,
    ButtonNext,
    Dropdown,
    DropdownMenu,
  },
  props: {
    chunk: {
      type: Object,
      required: true,
    },
  },
  emits: ['edit', 'toggleStatus', 'delete'],
  computed: {
    isDraft() {
      return this.chunk.status === 'draft';
    },
    contextMenuItems() {
      return [
        {
          label: this.$t(
            'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.ITEM.CONTEXT_MENU.EDIT'
          ),
          action: 'edit',
          value: 'edit',
        },
        {
          label: this.isDraft
            ? this.$t(
                'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.ITEM.CONTEXT_MENU.ENABLE'
              )
            : this.$t(
                'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.ITEM.CONTEXT_MENU.DISABLE'
              ),
          action: 'toggleStatus',
          value: 'toggleStatus',
        },
        {
          label: this.$t(
            'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.ITEM.CONTEXT_MENU.DELETE'
          ),
          action: 'delete',
          value: 'delete',
        },
      ];
    },
  },
  methods: {
    confirmChunkDeletion() {
      this.$emit('delete');
    },
    confirmToggleChunkStatus() {
      this.$emit('toggleStatus');
    },
    confirmEditChunk() {
      this.$emit('edit');
    },
    handleContextMenuAction({ action }, toggle) {
      if (action === 'edit') {
        this.$emit('edit');
      } else if (action === 'toggleStatus') {
        this.$emit('toggleStatus');
      } else if (action === 'delete') {
        this.$emit('delete');
      }
      toggle();
    },
  },
};
</script>

<template>
  <div class="flex gap-2">
    <template v-if="chunk.chunk_type === 'text'">
      <div
        class="chunk-item relative"
        :class="{
          'opacity-50': isDraft,
        }"
      >
        <DraftIndicator v-if="isDraft" />
        <div class="px-3 py-2">
          <span class="text-n-slate-11 text-xs">
            {{
              $t(
                'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.ITEM.TEXT.LABEL'
              )
            }}
          </span>
          <div class="text-sm text-n-slate-12">
            {{ chunk.text }}
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="chunk.chunk_type === 'qna'">
      <div
        class="chunk-item relative"
        :class="{
          'opacity-50': isDraft,
        }"
      >
        <DraftIndicator v-if="isDraft" />

        <div class="px-3 py-2">
          <span class="text-n-slate-11 text-xs">
            {{
              $t(
                'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.ITEM.QUESTION.LABEL'
              )
            }}
          </span>
          <div class="text-sm text-n-slate-12">
            {{ chunk.question }}
          </div>
        </div>

        <div class="px-3 py-2">
          <span class="text-n-slate-11 text-xs">
            {{
              $t(
                'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.ITEM.ANSWER.LABEL'
              )
            }}
          </span>
          <div class="text-sm text-n-slate-12">
            {{ chunk.answer }}
          </div>
        </div>
      </div>
    </template>

    <Dropdown align="end">
      <template #trigger="{ toggle }">
        <ButtonNext
          icon="i-lucide-ellipsis-vertical"
          color="slate"
          size="xs"
          variant="ghost"
          class="rounded-md group-hover:bg-n-alpha-2 mx-1"
          @click="toggle"
        />
      </template>
      <template #default="{ toggle }">
        <DropdownMenu
          class="!static"
          :menu-items="contextMenuItems"
          @action="e => handleContextMenuAction(e, toggle)"
        />
      </template>
    </Dropdown>
  </div>
</template>

<style scoped lang="scss">
.chunk-item {
  @apply grow rounded-xl shadow-sm border border-n-strong bg-n-solid-2 dark:bg-n-solid-3;
}
</style>
